<template>
  <div class="home">
    <div class="container">
      <el-carousel
        :interval="3000"
        arrow="never"
        height="600px"
        @change="bannerChange"
        ref="carousel"
      >
        <el-carousel-item
          v-for="item in data"
          :key="item.developer"
        >
          <div class="item" :style="[disStyle]">
            <el-image
              class="image"
              style="width: 100vw; height: 600px"
              :src="item.cases"
              :alt="item.title"
              fit="cover"
            >
            </el-image>
            <div class="left">
              <div class="carousel">
                <div class="title" :style="item.titleStyle || {}">{{ item.title }}</div>
                <div class="text" :style="item.developerStyle || {}">{{ item.developer }}</div>
                <div class="first-word-big-button" @click="goReservation(item.type)" data-agl-cvt="5">{{ item.text }}</div>
                <div 
                  v-if="item.count" 
                  class="first-word-big-button button-two"
                  @click="goPage(item.https,item.goCases)"
                >
                  {{ item.count }}
                </div>
              </div>
            </div>
          </div>
          
        </el-carousel-item>
      </el-carousel>
      <div class="carousel-content">
        <div class="carousel-card">
          <div class="carousel-solution">
            <solution-card :dataSouce="card" />
          </div>
        </div>
      </div>
    </div>
    <div class="container min-phone">
      <el-carousel
        :interval="5000"
        arrow="never"
        class="min-carousel"
       
      >
        <el-carousel-item
          class="item"
          v-for="item in data"
          :key="item.developer"
        >
          <el-image
            class="image"
            :src="item.minCases"
            :alt="item.title"
            fit="cover"
          ></el-image>
          <div class="left">
            <div class="carousel">
              <div class="title" :style="item.minTitleStyle || {}">{{ item.title }}</div>
              <div class="text" :style="item.minDeveloperStyle || {}">{{ item.developer }}</div>
              <div class="first-word-big-button" :style="{marginRight: item.count ? '0.2rem' : 0}" @click="goReservation(item.type)" data-agl-cvt="5">{{ item.text }}</div>
              <div v-if="item.count" class="first-word-big-button button-two" @click="goPage(item.https,item.goCases)">{{ item.count }}</div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="carousel-content">
        <div class="carousel-card">
          <div class="carousel-solution">
            <solution-card :dataSouce="card" />
          </div>
        </div>
      </div>
    </div>
    <div class="home-con-box home-con-box1">
      <div class="cultural-wall">
        <new-menu></new-menu>
      </div>
      <menu-conent></menu-conent>
    </div>
    <!-- 客户公司 -->
    <customer-recognition></customer-recognition>
    <!-- 数字化营销领导者 -->
    <digital-marketing></digital-marketing>
    <!-- 升级 -->
    <marketing-upgrade></marketing-upgrade>
  </div>
</template>

<script>
import customerRecognition from '@/components/CustomerRecognition.vue'
import digitalMarketing from '@/components/DigitalMarketing.vue'
import marketingUpgrade from '@/components/MarketingUpgrade.vue'
import newMenu from './components/newMenu.vue'
import menuConent from './components/menuConent.vue'
import swTracker from '@/mixins/tracker.js'
import SolutionCard from "./components/Card.vue";

export default {
  name: "HomeView",
  mixins: [swTracker],
  components: {
    customerRecognition,
    digitalMarketing,
    marketingUpgrade,
    newMenu,
    menuConent,
    SolutionCard
  },
  data () {
    return {
      onVideoSrc: '',
      carousel: "https://cdn.ideamake.cn/sw-pc/images/all-round-solution.png",
      currentIndex: 0,
      data: [
        {
          type: 2,
          developer: "思为营销云，专注中国房地产数字化营销12年，已成为先进房企的共同选择",
          title: "赋能数字营销，更赋能数字管理",
          text: "立即体验",
          count: "",
          cases: "https://cdn.ideamake.cn/sw-pc/images/home-banner-one.png",
          minCases: "https://cdn.ideamake.cn/sw-pc/images/min-home-banner-one.png",
        },
        {
          type: 1,
          developer: "更智能的营销CRM",
          title: "销冠CRM",
          titleStyle: { marginLeft: '145px', marginTop: '-60px'  },
          minTitleStyle: { textAlign: 'left', margin: '-0.22rem 0 0.04rem 1.4rem' },
          developerStyle: { marginLeft: '145px', marginBottom: '122px' },
          minDeveloperStyle: { textAlign: 'left', margin: '0 0 0.32rem 1.4rem' },
          text: "立即体验",
          count: "",
          cases: "https://cdn.ideamake.cn/sw-pc/images/home-banner-zero.png",
          minCases: "https://cdn.ideamake.cn/sw-pc/images/min-home-banner-zero.png",
        },
        {
          type: 3,
          developer: "立即掌握快速拓客的全民营销新玩法",
          title: "《新时代全民营销策略白皮书》首发",
          text: "获取方案",
          count: "更多案例",
          goCases: true,
          cases: "https://cdn.ideamake.cn/sw-pc/images/home-banner-three.png",
          minCases: "https://cdn.ideamake.cn/sw-pc/images/min-home-banner-three.png",
          https: 'cases',
        },
      ],
      card: [
        {
          title: "行业报告",
          list: [
            "国央企数字化营销白皮书",
          ],
          text: '立即下载',
          code: false,
          type: 2,
          img: 'https://cdn.ideamake.cn/sw-pc/images/card-one.png',
          banner: 'https://cdn.ideamake.cn/sw-pc/images/card-background-one.png'
        },
        {
          title: "前沿打法",
          list: [
            "新时代全民营销策略白皮书",
          ],
          text: '立即获取',
          code: false,
          type: 3,
          img: 'https://cdn.ideamake.cn/sw-pc/images/card-two.png',
          banner: 'https://cdn.ideamake.cn/sw-pc/images/card-background-two.png'
        },
        {
          title: "优质案例",
          list: [
            "抖音直播如何实现客户留资率10倍提升？",
          ],
          text: '立即了解',
          code: true,
          type: 4,
          img: 'https://cdn.ideamake.cn/sw-pc/images/card-three.png',
          banner: 'https://cdn.ideamake.cn/sw-pc/images/card-background-three.png'
        },
      ],
      discountStyle: 0
    }
  },
  computed: {
    disStyle () {
      const colorMap = {
        0: '#d0e7ff',
        1: '#cce3ff',
        2: '#d6e4fe',
        3: '#c6d9ff',
      }
      return  {
        background:`${colorMap[this.discountStyle]}`
      }
    },
  },
  mounted() {
    // Preload banner images to ensure smooth transitions
    this.data.forEach(item => {
      const img = new Image();
      img.src = item.cases;
      const minImg = new Image();
      minImg.src = item.minCases;
    });
  },
  methods: {
    bannerChange(index) {
      this.currentIndex = index;
      this.discountStyle = index;
    },
    carouselData (data) {
      this.carousel = data;
      let box2 = this.$refs.box2;
      if (box2) {
        box2.style.background = 'url('+data+')';
      }
    },
    // 跳转立即体验
    goExperience() {
      this.$router.push({ path: '/experience' });
    },
    // 跳转预约演示
    goReservation(type) {
      this.$router.push({ path: '/reservation', query: { type } });
      // 调用百度统计的代码
      switch (type) {
        case 0:
          window._hmt.push(['_trackEvent', 'button','click', '首页轮播第一张立即体验按钮']);
          break;
        case 1:
          window._hmt.push(['_trackEvent', 'button','click', '首页轮播第二张立即体验按钮']);
          break;
        case 2:
          window._hmt.push(['_trackEvent', 'button','click', '首页轮播第三张立即获取按钮']);
          break;
        case 3:
          window._hmt.push(['_trackEvent', 'button','click', '首页轮播第四张获取方案按钮']);
          break;
      }
    },
    goPage(https, goCases) {
      if(goCases) {
        window._hmt.push(['_trackEvent', 'button','click', '首页第三张轮播更多案例按钮']);
        this.$router.push({ path: https });
      } else {
        window._hmt.push(['_trackEvent', 'button','click', '首页第四张轮播更多干货按钮']);
        window.open(https, '_blank');
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import "./home";
.fixed{
  position: fixed;
  top: 0;
  left: 0;
}
// 移动端布局
@import "@/views/home/min-home";

// 强制设置移动端banner标题字体大小
@media screen and (max-width: 980px) {
  .home .container.min-phone .item .left .carousel .title {
    font-size: 0.24rem !important;
  }
}
@media screen and (max-width: 980px) {
  .home{
    .container{
      display: none;
      &.min-phone{
        display: block;
        .item {
          margin-top: 0.62rem;
          height: 4.66rem;
          background-size: 390px 466px;
          text-align: center;
          .image {
            width: 100%;
            height: 100%;
          }
          .left{
            .carousel {
              width: 100%;
              top: 10%;
            }
            .title {
              font-size: 0.24rem !important;
              font-weight: 500;
              color: #2D2E30;
              line-height: 0.28rem;
            }
            .carousel .title {
              font-size: 0.24rem !important;
            }
            .carousel .title[style] {
              font-size: 0.24rem !important;
            }
            .text {
              font-size: 0.14rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #2D2E30;
              line-height: 0.24rem;
              margin-bottom: 0.24rem;
              margin-top: 0.05rem;
            }
          }
        }
        .carousel-card {
          width: 100%;
          .card{
            justify-content: space-around;
            flex-wrap: wrap;
            height: 5.40rem;
          }
          .carousel-solution {
            margin-top: -0.28rem;
          }
        }
        ::v-deep .el-carousel__indicators--horizontal {
            bottom: 0.55rem;
            width: 3.90rem;
            text-align: center;
            margin-left: 0rem;
            .el-carousel__button {
              width: 0.20rem;
            }
          }
      }
      .min-carousel{
        height: 5.793rem;  
      }
    }
  }
}

@media screen and (min-width: 1920px) {
  .home{
    .container{
      .item{
        text-align: center;
        overflow: hidden;
        .left{
          .carousel{
            text-align: left;
          }
        }
        .image {
          width: 1920px !important;
        }
      }
      
    }
  }
}
</style>
